module.exports = __webpack_public_path__ + "img/2.6f1b3c7a.png";